import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import App from './App.vue';
import router from './router';
import './styles/index.css';

// 抑制 ResizeObserver 警告
const resizeObserverLoopErrRe = /^[^(]*ResizeObserver loop/;
const resizeObserverLoopErrRe2 = /^ResizeObserver loop completed with undelivered notifications/;

const originalError = window.console.error;
window.console.error = (...args) => {
  if (
    args.length > 0 &&
    typeof args[0] === 'string' &&
    (resizeObserverLoopErrRe.test(args[0]) || resizeObserverLoopErrRe2.test(args[0]))
  ) {
    return;
  }
  // 过滤掉 Event 对象的错误
  if (args.length > 0 && args[0] instanceof Event) {
    return;
  }
  originalError.apply(console, args);
};

// 全局错误处理器 - 防止 Event 对象被传递到错误处理器
window.addEventListener('error', (event) => {
  // 如果错误对象本身就是 Event，不处理
  if (event.error instanceof Event) {
    event.preventDefault();
    return false;
  }
}, true);

// 全局未处理的 Promise 拒绝处理器
window.addEventListener('unhandledrejection', (event) => {
  // 如果拒绝的原因是 Event 对象，不处理
  if (event.reason instanceof Event) {
    event.preventDefault();
    return false;
  }
});

const app = createApp(App);
app.use(Antd);
app.use(router);
app.mount('#app');

